// extracted by mini-css-extract-plugin
export default {"collection":"ListCard_collection__FCPnl","viewGrid":"ListCard_viewGrid__-UbAt"};